import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import { Trophy, ArrowRight, Calendar, Medal } from "lucide-react";

export default function Results() {
  const [editions, setEditions] = useState(null);

  useEffect(() => {
    api.get("/results/archive").then(({ data }) => setEditions(data.editions)).catch(() => setEditions([]));
  }, []);

  return (
    <div className="App" data-testid="results-archive-page">
      <Navbar />
      <div className="relative">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-16 lg:py-24 min-h-[60vh]">
          <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
            <div className="lg:col-span-4 lg:sticky lg:top-24 lg:self-start">
              <div className="label-eyebrow mb-3 flex items-center gap-2"><Trophy className="w-4 h-4 text-brand" strokeWidth={1.5} /> Results Archive</div>
              <h1 className="font-display text-4xl sm:text-6xl text-white leading-none tracking-tight">Results Archive</h1>
              <p className="text-gray-400 mt-5 text-lg max-w-sm leading-relaxed">Every edition. Every winner. Every idea that made it.</p>
            </div>

            <div className="lg:col-span-8">
              {editions === null ? (
                <div className="text-gray-500 font-mono text-sm" data-testid="results-loading">Loading…</div>
              ) : editions.length === 0 ? (
                <div className="border border-white/10 bg-[#111827] px-8 py-16" data-testid="results-empty">
                  <Trophy className="w-9 h-9 text-brand mb-6" strokeWidth={1.5} />
                  <div className="font-display text-2xl sm:text-3xl text-white tracking-tight">No results announced yet.</div>
                  <p className="text-gray-400 mt-3 max-w-sm leading-relaxed">Winners and full team profiles will be published here once results go live.</p>
                </div>
              ) : (
                <div className="grid sm:grid-cols-2 gap-5">
                  {editions.map((e) => (
                    <Link to={`/results/${e.slug}`} key={e.slug} className="card-surface hover:border-brand/40 transition-colors group" data-testid={`edition-card-${e.slug}`}>
                      <div className="flex items-center justify-between">
                        <div className="font-display text-2xl text-white">{e.edition_label}</div>
                        <span className="badge badge-finalist inline-flex items-center gap-1"><Trophy className="w-3 h-3" strokeWidth={2} /> Announced</span>
                      </div>
                      {e.announced_at && (
                        <div className="text-xs text-gray-500 mt-2 flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {new Date(e.announced_at).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" })}</div>
                      )}
                      <div className="mt-5 border-t border-white/5 pt-4">
                        <div className="label-eyebrow mb-1 flex items-center gap-1.5"><Medal className="w-3.5 h-3.5 text-[#FBBF24]" strokeWidth={1.75} /> Rank 1</div>
                        <div className="text-white font-medium">{e.rank1_team || "—"}</div>
                        <div className="text-sm text-gray-400">{e.rank1_project || ""}</div>
                      </div>
                      <div className="mt-4 flex items-center justify-end">
                        <span className="text-brand text-sm flex items-center gap-1 group-hover:gap-2 transition-[gap]">View Results <ArrowRight className="w-4 h-4" /></span>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
